import gsap from 'gsap';
import { defineComponent, inject, provide, ref } from 'vue';

import { useRaf } from '@resn/gozer-vue';

export const MatcapKey = Symbol('Matcap');

export const useMatcap = () => {
    const provider = inject(MatcapKey);

    if (!provider) {
        throw new Error('Matcap provider not found');
    }

    return provider;
};

export const MatcapProvider = defineComponent({
    props: {},

    setup() {
        const rotation = ref(0);
        const speed = ref(1);

        const updateSpeed = (val, { duration = 1 } = {}) => {
            gsap.killTweensOf(speed);
            gsap.to(speed, {
                duration,
                val,
                ease: 'power2.inOut',
            });
        };

        const provider = {
            rotation,
            speed,
            updateSpeed,
        };

        useRaf(({ delta }) => {
            rotation.value += (delta / 1000) * speed.value;
        });

        provide(MatcapKey, provider);
    },

    render() {
        if (this.$slots.default) {
            return this.$slots.default();
        }

        return null;
    },
});
